import { Component, ElementRef, ViewChild, ChangeDetectionStrategy, OnInit /*, Inject, AfterViewInit, PLATFORM_ID, ChangeDetectorRef, ElementRef, ContentChildren, QueryList, ViewChild*/ } from '@angular/core';
import { routeAnimation, slideOutAnimation, footerAnimation, holdHeightAnimation } from '@app/animations';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map, tap, switchMap, skipWhile, filter, startWith, shareReplay, takeUntil, distinctUntilChanged, take } from 'rxjs/operators';
import { RxStrategyProvider } from '@rx-angular/cdk/render-strategies';
import { DataService, PlatformService, AnimationService } from '@app/data';

import { EventTypes, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  animations: [routeAnimation, slideOutAnimation, footerAnimation, holdHeightAnimation]
})
export class AppComponent implements OnInit {

  private isBrowser = this.platform.isBrowser;
  public routeAnimationParams$ = this.data.getRouteAnimationParams$();

  public holdMainHeight$ = this.animation.holdMainHeight$;

  private renderStrategy = this.isBrowser ? 'local' : 'global';
  
  constructor( 
    private element: ElementRef,
    private platform: PlatformService,
    private data: DataService,
    private animation: AnimationService,
    private strategyProvider: RxStrategyProvider,
    public oidcSecurityService: OidcSecurityService, 
    private eventService: PublicEventsService
  ) {
    
    if (this.isBrowser && history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }

  }

  ngOnInit():void {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, userData, accessToken, idToken, configId }) => {
          console.log('AppComponent app authenticated', isAuthenticated);
          console.log(`AppComponent Current access token is '${accessToken}'`);
        });

        this.eventService
          .registerForEvents()
          .pipe(filter((notification) => notification.type === EventTypes.CheckSessionReceived))
          .subscribe((value) => console.log('AppComponent CheckSessionReceived with value from app', value));
  }

  //public getRouteAnimationParams = (): any => this.data.getRouteAnimationParams();

  public onAnimationStartEvent($event: any) {
    //console.log('AppComponent **** @routeAnimation **** onAnimationStartEvent $event ', $event);
    //console.log('AppComponent **** @routeAnimation **** onAnimationStartEvent this.elementRef.nativeElement[0].querySelector(.ng-star-inserted) ', this.elementRef.nativeElement[0].querySelector('.ng-star-inserted'));

    //const enter = (this.main as any).querySelector.apply(this.main, ['.ng-enter']);
    //const enter = (this.main as any).querySelector.apply(this.main, ['.ng-star-inserted']);
    //const enter = (this.main as any).querySelector('router-outlet');
    //console.log('AppComponent **** @routeAnimation **** onAnimationStartEvent this.routedElements ', this.routedElements);

    //this.hideFooter$.next('hide');  

    /*this.strategyProvider.schedule(() => {
      

    }, {strategy: 'local'}).pipe(take(1)).subscribe();*/

    this.onAnimationStart();


  }

  public onAnimationDoneEvent(event: any) {
    //console.log('AppComponent **** @routeAnimation **** onAnimationDoneEvent event', event);
    //console.log('AppComponent **** @routeAnimation **** onAnimationDoneEvent this.data.getCurrentPage().offsetY', this.data.getCurrentPage().offsetY);

    /*this.strategyProvider.schedule(() => {
      
    }, { strategy: this.renderStrategy }).pipe(take(1)).subscribe();*/
    
    this.onAnimationEnd();
    
  }

  public onFooterAnimationDoneEvent(event: any) {
  //console.log('AppComponent **** @footerAnimation **** onFooterAnimationDoneEvent event', event);
    
  }





  private onAnimationStart = (): void => {

    /*if (this.isBrowser) {
      const enter = (<Element>this.element.nativeElement).querySelector('.main-outlet > *:nth-child(2)');
      const leave = (<Element>this.element.nativeElement).querySelector('.main-outlet > *:nth-child(3)');
      //const card = (<Element>this.element.nativeElement).querySelector('app-card');
      
      //console.log('AppComponent **** onAnimationStart **** enter!.innerHTML', enter!.innerHTML);
      //console.log('AppComponent **** onAnimationStart **** enter.clientHeight', enter!.clientHeight);
      //console.log('AppComponent **** onAnimationStart **** leave.clientHeight', leave!.clientHeight);

      if (enter) {
        console.log('AppComponent **** onAnimationStart **** enter.clientHeight', enter.clientHeight);

        //setStyle(enter, 'height', enter.clientHeight + 'px'); 

      }

      if (leave) {
        console.log('AppComponent **** onAnimationStart **** leave.clientHeight', leave.clientHeight);

        //setStyle(leave, 'height', leave.clientHeight + 'px'); 

        this.animation.holdMainHeight(true);
      }
    }*/
  }

  private onAnimationEnd = (): void => {

    const offset = this.data.getCurrentPage().offsetY;

    this.data.scrollToPosition([0, offset]);

    //this.animation.holdMainHeight(false);
    
  }
}

